// @ts-nocheck
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { resetPassword } from "../api/auth";
import { getErrorMessage } from "../api/client";
import "../styles/Login.css";
import cardexLogo from "../assets/Cardex Login Final Logo.png";

// Supabase recovery links return the session in the URL hash:
//   #access_token=...&refresh_token=...&type=recovery
// (or #error=...&error_description=... when the link is invalid/expired).
function readRecoveryParams() {
  const hash = (window.location.hash || "").replace(/^#/, "");
  const search = (window.location.search || "").replace(/^\?/, "");
  const params = new URLSearchParams(hash || search);
  return {
    accessToken: params.get("access_token") || "",
    error: params.get("error_description") || params.get("error") || "",
  };
}

export default function ResetPassword() {
  const navigate = useNavigate();
  const [{ accessToken, error: linkError }] = useState(readRecoveryParams);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!accessToken) {
      setError("This reset link is invalid or has expired. Please request a new one.");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    if (loading) return;
    setLoading(true);
    try {
      await resetPassword(accessToken, password);
      setDone(true);
    } catch (err) {
      setError(getErrorMessage(err, "Couldn't reset your password. The link may have expired."));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <main className="screen auth-screen forgot-screen">
        <div className="bg-glow" />
        <div className="login-grid-lines" aria-hidden="true"></div>
        <div className="login-noise" aria-hidden="true"></div>

        <div className="login-scene auth-scene forgot-scene">
          <section className="hero login-hero auth-hero">
            <img src={cardexLogo} alt="Cardex" className="logo" />
            <h1 className="title auth-title">
              Password
              <br />
              updated
            </h1>
            <p className="subtitle auth-subtitle">
              Your password has been changed. Sign in with your new password to get back into Cardex.
            </p>
          </section>

          <section className="card login-panel forgot-panel" aria-label="Reset complete">
            <div className="login-panel-glow" aria-hidden="true"></div>
            <div className="form">
              <button className="btn-primary login-submit" type="button" onClick={() => navigate("/login")}>
                <span>Back to login</span>
              </button>
            </div>
          </section>
        </div>
      </main>
    );
  }

  return (
    <main className="screen auth-screen forgot-screen">
      <div className="bg-glow" />
      <div className="login-grid-lines" aria-hidden="true"></div>
      <div className="login-noise" aria-hidden="true"></div>

      <div className="login-scene auth-scene forgot-scene">
        <section className="hero login-hero auth-hero">
          <img src={cardexLogo} alt="Cardex" className="logo" />
          <h1 className="title auth-title">
            Choose a new
            <br />
            password
          </h1>
          <p className="subtitle auth-subtitle">
            Pick a strong password you don&apos;t use anywhere else to secure your Cardex account.
          </p>
        </section>

        <section className="card login-panel forgot-panel" aria-label="Reset password form">
          <div className="login-panel-glow" aria-hidden="true"></div>
          <div className="login-panel-top">
            <div>
              <p className="login-panel-kicker">Reset password</p>
              <h2 className="login-panel-title">New password</h2>
            </div>
          </div>

          <form className="form" onSubmit={handleSubmit}>
            {(error || linkError) && <div className="error-msg">{error || linkError}</div>}

            <label className="label" htmlFor="password">New Password</label>
            <div className="input-wrap">
              <input
                id="password"
                name="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>

            <label className="label" htmlFor="confirm">Confirm Password</label>
            <div className="input-wrap">
              <input
                id="confirm"
                name="confirm"
                type="password"
                placeholder="••••••••"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>

            <button className="btn-primary login-submit" type="submit" disabled={loading || !accessToken}>
              <span>{loading ? "Saving…" : "Update password"}</span>
            </button>
          </form>

          <footer className="footer login-footer">
            <p>
              <Link className="link strong" to="/login">Back to login</Link>
            </p>
          </footer>
        </section>
      </div>
    </main>
  );
}
